(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prevura-review-link"] && !Shopify.designMode) return;
  try {
    function syncPrevuraReviewLinks() {
    document.querySelectorAll('[data-prevura-review-link]').forEach((link) => {
      const source = document.getElementById(link.hash.slice(1));
      const count = Number(source?.dataset.reviewCount);
      const rating = Number(source?.dataset.reviewRating);
      const available = source?.dataset.reviewSummaryEnabled === 'true' &&
        Number.isInteger(count) && count > 0 && Number.isFinite(rating) && rating >= 1 && rating <= 5;
      const stars = link.querySelector('[data-prevura-review-stars]');
      const caption = link.querySelector('[data-prevura-review-caption]');
      if (!stars || !caption) return;
      link.hidden = !source;
      stars.hidden = !available;
      if (available) {
        const label = new Intl.NumberFormat(document.documentElement.lang || 'de', {
          minimumFractionDigits: 1, maximumFractionDigits: 1,
        }).format(rating);
        caption.textContent = link.dataset.summaryLabel.replace('{rating}', label).replace('{count}', String(count));
        const sourceLabel = link.dataset.sourceLabel.replace('{rating}', label).replace('{count}', String(count));
        link.setAttribute('aria-label', sourceLabel);
        link.setAttribute('title', sourceLabel);
        stars.style.setProperty('--pv-pdp-rating-fill', `${rating * 20}%`);
      } else {
        caption.textContent = link.dataset.fallbackLabel;
        link.removeAttribute('aria-label');
        link.removeAttribute('title');
        stars.style.removeProperty('--pv-pdp-rating-fill');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPrevuraReviewLinks, { once: true });
  } else {
    syncPrevuraReviewLinks();
  }
  document.addEventListener('shopify:section:load', syncPrevuraReviewLinks);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncPrevuraReviewLinks));
  } catch(e) { console.error(e); }
})();

})();
